module.exports = __webpack_public_path__ + "static/media/SuperMarket.8b8ec0fc.svg";